<app-waiting-list class="subpage-content"></app-waiting-list>

<div #dialogFooter></div>
